import { faAward, faCertificate, faUserAstronaut } from '@fortawesome/free-solid-svg-icons'

const BlockData = [
    {
        id: 1,
        class: 'about-box-1',
        icon: faAward,
        heading: '8 Years Job',
        text: 'Experience',
    },
    {
        id: 2,
        class: 'about-box-2',
        icon: faCertificate,
        heading: '500+ Projects',
        text: 'Completed',
    },
    {
        id: 3,
        class: 'about-box-3',
        icon: faUserAstronaut,
        heading: 'Freelance',
        text: 'Available',
    }
]

export default BlockData